import genererCalculAutoTlpeJour from '@/services/dcf/tlpe/model/genererCalculAutoTlpeJour';
import calculMonthsBetweenTwoDate
  from '@/services/general/calculMonthsBetweenTwoDate';
import calculDaysBetweenTwoDate
  from '@/services/general/calculDaysBetweenTwoDate';
import calculArrondi from '@/services/calcul/calculArrondi';

import {
  CATEGORIE_REGROUPEMENT,
  CATEGORIE_REGROUPEMENT_LC, CATEGORIE_DIVERS, CATEGORIE_LOCATION,
  CATEGORIE_REGROUPEMENT_NUMERIQUE, CATEGORIE_UNITAIRE, CATEGORIE_ECRAN_NUMERIQUE,
} from '@/configuration/catalogue/produitConf';
import genererCalculAutoTlpeSemaine
  from '@/services/dcf/tlpe/model/genererCalculAutoTlpeSemaine';
import formatDate from '@/services/general/formatIsoDate';
import { calculTlpeJour, calculTlpeSemaine } from '@/api/gabed/materiel';
import * as devisConf from '@/configuration/devisConf';
import moment from 'moment';

function calculQuantite(ligneRegroupement) {
  // verifie si ce sont des mois complet et calcul leurs nombres
  const nbMois = Number(calculMonthsBetweenTwoDate(ligneRegroupement.dateDebut,
    ligneRegroupement.dateFin));
  if (nbMois !== 0) {
    return calculArrondi(nbMois / 12, 5);
  }
  const nbJours = Number(calculDaysBetweenTwoDate(ligneRegroupement.dateFin,
    ligneRegroupement.dateDebut)) + 1;
  return calculArrondi(nbJours / 365, 5);
}

export async function calculAutoTlpeSemaine(
  ligneRegroupement, ligneTlpe, repartitionSurFacture, pourFacture,
) {
  const tlpeSemaine = genererCalculAutoTlpeSemaine();

  tlpeSemaine.produitId = ligneRegroupement.produitId;
  tlpeSemaine.anneeSemaine = ligneRegroupement.ligneReseau.anneeSemaine;
  tlpeSemaine.quantiteSouhaitee = ligneRegroupement.ligneReseau.qteFacesSouhaitees;

  if (ligneRegroupement.ligneReseau.lignesCmdSelProduits.length > 0) {
    tlpeSemaine.produitsFacesSelectionnes = ligneRegroupement
      .ligneReseau.lignesCmdSelProduits.map((el) => {
        return el.produitId;
      });
  }

  const montantTlpe = (await calculTlpeSemaine(tlpeSemaine)).data.result;
  ligneTlpe.prixUnitaire = (montantTlpe?.montant ?? 0) * (repartitionSurFacture ?? 1);
  ligneTlpe.quantite = 1;
  ligneTlpe.uniteVente = pourFacture ? devisConf.UNITE : devisConf.SEMAINE;
  ligneTlpe.totalHt = ligneTlpe.prixUnitaire * ligneTlpe.quantite;
}

export async function calculAutoTlpeJour(
  ligneRegroupement, ligneTlpe, surPeriode, repartitionSurFacture, pourFacture,
) {
  const tlpeJour = genererCalculAutoTlpeJour();

  tlpeJour.dateDebut = formatDate(ligneRegroupement.dateDebut);
  // Si souhaite la TLPE pour un an et on joue sur la quantite, sauf pour les factures
  tlpeJour.dateFin = pourFacture || !surPeriode ? formatDate(ligneRegroupement.dateFin) : formatDate(moment(ligneRegroupement.dateDebut).add(1, 'y').subtract(1, 'd'));
  tlpeJour.produitId = ligneRegroupement.produitId;
  tlpeJour.surAnnee = !pourFacture;
  if ([CATEGORIE_ECRAN_NUMERIQUE, CATEGORIE_REGROUPEMENT_NUMERIQUE]
    .includes(ligneRegroupement.typeProduit)) {
    tlpeJour.quantiteDispo = 1; // si on ne peut pas selectionné la quantite je la met à 1
  } else tlpeJour.quantiteDispo = ligneRegroupement.quantiteDispo;

  const montantTlpe = (await calculTlpeJour(tlpeJour)).data.result;

  ligneTlpe.uniteVente = surPeriode ? devisConf.ANNEE : devisConf.UNITE;
  ligneTlpe.quantite = surPeriode ? calculQuantite(ligneRegroupement) : 1;
  ligneTlpe.prixUnitaire = (montantTlpe?.montant ?? 0) * (repartitionSurFacture ?? 1);
  if (pourFacture) {
    ligneTlpe.uniteVente = devisConf.UNITE;
    ligneTlpe.quantite = 1 * (repartitionSurFacture ?? 1);
    ligneTlpe.prixUnitaire = montantTlpe?.montant ?? 0;
  }
}

// surPeriode = parametre periodeTotalCalculTlpeAuto
export default async function calculTlpe(ligneRegroupement, pourFacture,
  surPeriode, repartitionSurFacture) {
  // si aucune ligne de TLPE pas de calcul
  if (ligneRegroupement.lignesCommande.filter((el) => {
    return el.typeProduit === CATEGORIE_DIVERS
      && el.produit?.produitDivers?.tlpe
      && el.calculAutomatiqueTlpe;
  }).length === 0) return;

  // si il n'y a pas de produit de location on ne doit pas pouvoir calculer la TLPE
  if (ligneRegroupement.lignesCommande.filter((el) => {
    return el.typeProduit === CATEGORIE_LOCATION;
  }) > 0) return;

  // initalisation de la ligne TLPE
  const ligneTlpe = ligneRegroupement.lignesCommande.find((el) => {
    return el.typeProduit === CATEGORIE_DIVERS && el.produit?.produitDivers?.tlpe;
  });

  ligneTlpe.lignesRemise = [];
  ligneTlpe.remise = 0;

  // calcul de la TLPE
  switch (ligneRegroupement.typeProduit) {
    case CATEGORIE_REGROUPEMENT:
      await calculAutoTlpeSemaine(ligneRegroupement, ligneTlpe, repartitionSurFacture, pourFacture);
      break;
    case CATEGORIE_REGROUPEMENT_LC:
    case CATEGORIE_REGROUPEMENT_NUMERIQUE:
    case CATEGORIE_UNITAIRE:
    case CATEGORIE_ECRAN_NUMERIQUE:
      await calculAutoTlpeJour(
        ligneRegroupement, ligneTlpe, surPeriode, repartitionSurFacture, pourFacture,
      );
      break;
    default:
      break;
  }
}
